import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-20 md:py-24 px-4 bg-white" data-id="element-294" data-mp="coiskmopx5mr">
      <div className="max-w-6xl mx-auto" data-id="element-295" data-mp="cnzc7aepupau">
        <div className="text-center mb-14" data-id="element-296" data-mp="7peky0hfzfyj">
          <p className="text-orange font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-297" data-mp="7qpqo5ug6xsa">
            What you get: 6 complete resources in one package
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold uppercase mb-4 text-charcoal" data-id="element-298" data-mp="3c3wb27l2s26c">
            The <span className="text-orange" data-id="element-299" data-mp="3pvkm07jl8klq">6-Volume</span> Coaching Library
          </h2>
          <p className="text-xl text-warmgray" data-id="element-300" data-mp="3l4kq95m7g8kt">
            120 complete sessions · All levels covered · Nothing to build from
            scratch
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-301" data-mp="2xcnch8z736h2">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-ivory rounded-2xl border ${volume.popular ? 'border-orange shadow-[0_16px_40px_-24px_rgba(242,106,27,0.8)]' : 'border-orange/30 shadow-sm'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-302" data-mp="2sdkj4lskuoox" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-orange text-white font-bold text-[11px] tracking-wider py-1 px-10 rotate-45 shadow" data-id="element-303" data-mp="24gfhxwn5968e">
                  MOST USED
                </div>}
              <div className="mb-6" data-id="element-304" data-mp="3fvavtgdyv3nw">
                <div className="text-orange font-bold text-sm uppercase tracking-wider" data-id="element-305" data-mp="3fu9i145kg32h">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-display font-bold uppercase leading-tight mt-1 text-charcoal pr-16" data-id="element-306" data-mp="1brq409eefk7b">
                  {volume.title}
                </h3>
              </div>
              <p className="text-warmgray font-medium mb-6 italic border-l-2 border-orange pl-4" data-id="element-307" data-mp="1ppeld799c97m">
                {volume.subtitle}
              </p>
              <div className="mb-6" data-id="element-308" data-mp="x3va4ponn9sn">
                <h4 className="text-sm font-bold text-charcoal uppercase tracking-wider mb-2" data-id="element-309" data-mp="x33gvlij5o5j">
                  What this solves for your coaching
                </h4>
                <p className="text-warmgray text-sm leading-relaxed" data-id="element-310" data-mp="16tohtflof4rm">
                  {volume.problem}
                </p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-311" data-mp="1203i9j4fq2qb">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-312" data-mp="9d904sv3bfg0">
                    <CheckCircle2Icon size={18} className="text-orange shrink-0 mt-0.5" aria-hidden="true" data-id="element-313" data-mp="9czc3atlvicy" />
                    <span className="text-charcoal text-sm" data-id="element-314" data-mp="2psm5lbtdeu5v">{bullet}</span>
                  </li>)}
              </ul>
              <div className="bg-graphite rounded-xl p-4 mt-auto" data-id="element-315" data-mp="2gz0t5z4ohozm">
                <span className="text-orange font-bold uppercase text-sm block mb-1" data-id="element-316" data-mp="2gz943lh8qk86">
                  Result
                </span>
                <p className="text-white/85 text-sm" data-id="element-317" data-mp="38px4uwf05nlb">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}